/**
 * Fallback UI rendered by the app-root and route-level Sentry error
 * boundaries when a render error is caught.
 *
 * Intentionally dependency-free — no i18n or router hooks — so it still
 * renders when a context provider is what crashed. The English copy is the
 * one deliberate exception to the no-hardcoded-text rule: this is last-resort
 * UI shown when the app (and possibly LanguageProvider) is broken.
 */

export const ErrorFallback = () => (
  <div className="flex min-h-screen items-center justify-center bg-background p-4">
    <div className="text-center">
      <h1 className="mb-4 text-2xl font-semibold text-foreground">
        Something went wrong
      </h1>
      <p className="mb-6 text-muted-foreground">
        An unexpected error occurred. Please reload the page.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="rounded-md bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
      >
        Reload
      </button>
    </div>
  </div>
);

export default ErrorFallback;
